// extracted by mini-css-extract-plugin
export var addWidgetButton = "_y-6";
export var backButton = "_y-1";
export var legacyWidgetContainer = "_y-5";
export var pageContainer = "_y-2";
export var settingsContent = "_y-0";
export var widgetSubsectionItem = "_y-3";
export var widgetSubsectionItemContent = "_y-4";